<template>
  <div class="join-page">
    <TheAppBar />

    <v-overlay :value="isProccessing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-dialog v-model="isErrorVisible" persistent max-width="290">
      <v-card>
        <v-card-title class="join-page__error">Error</v-card-title>
        <v-card-text>
          Your link token is invalid or expired
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-content class="join-page__content" transition="out-in">
      <v-container>
        <v-fade-transition mode="out-in">
          <StepPersonalData
            v-if="currentStep === 'personal-data'"
            :processing="isSubmitProcessing"
            @submit="submitPersonalData"
          />

          <StepSurvey
            v-else-if="currentStep === 'survey'"
            :token="token"
          />
        </v-fade-transition>
      </v-container>
    </v-content>
  </div>
</template>

<script>
import developerApi from '@/api/v1/developer';
import TheAppBar from '@/components/TheAppBar.vue';
import StepPersonalData from '@/components/Developers/Join/StepPersonalData.vue';
import StepSurvey from '@/components/Developers/Join/StepSurvey.vue';

export default {
  metaInfo: {
    title: 'Join',
  },

  components: {
    TheAppBar,
    StepPersonalData,
    StepSurvey,
  },

  props: {
    token: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isProccessing: true,
      isErrorVisible: false,
      isSubmitProcessing: false,
      currentStep: '',
    };
  },

  mounted() {
    this.verifyToken();
  },

  methods: {
    verifyToken() {
      developerApi.accounts.validate(this.token)
        .then((resp) => {
          if (resp.data.section === 'soft_skills') {
            this.currentStep = 'survey';
          } else {
            this.currentStep = 'personal-data';
          }
        })
        .catch(() => {
          this.isErrorVisible = true;
        })
        .finally(() => {
          this.isProccessing = false;
        });
    },

    submitPersonalData(developerData) {
      this.isSubmitProcessing = true;

      developerApi.accounts.updatePersonalData(this.token, developerData)
        .then(() => {
          this.currentStep = 'survey';
        })
        .catch((err) => {
          this.$store.dispatch('showError', err.response.data.errors);
        })
        .finally(() => {
          this.isSubmitProcessing = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.join-page {
  margin-top: 0px;
  background: $color--bg;

  &__content {
    min-height: calc(100vh - 64px);
  }

  &__error {
    text-align: center;
    color: $color--primary;
  }
}
</style>
